const EMPTY = ''

module.exports = EMPTY
